import SectionWrapper from './SectionWrapper';
import AppleAppLinks from './AppleAppLinks';
import GoogleAppLinks from './GoogleAppLinks';
import { Flex } from '@chakra-ui/react';
import { useAppSelector } from '../../../store/redux/hooks';
import { BUILDER_DEVICE_TAB } from './utils/templateBuilderTabs';

const AppLinkingFeature = ({ selectedTab }: { selectedTab: string }) => {
  const appLinking = useAppSelector((s) => s.template.appLinking);
  const hasAppLinkingValues =
    !!appLinking?.appleAppStoreUrl?.some((url) => url && url.trim()) ||
    !!appLinking?.googleDisplayText?.trim() ||
    !!appLinking?.googleAppPackageName?.trim() ||
    !!appLinking?.googleAppPlayStoreUrl?.trim() ||
    !!appLinking?.googleWebUrl?.trim();

  return (
    <SectionWrapper
      id="app-linking-section"
      title="App Link"
      tooltip="Display a link to your App Store app on Apple Wallet passes and/or to your Google Play Store or web app on Google Wallet passes."
      subtitle={
        selectedTab === BUILDER_DEVICE_TAB.APPLE
          ? 'You can add up to 10 URLs.'
          : ''
      }
      selectedTab={selectedTab}
      autoOpenOnceWhen={hasAppLinkingValues}
    >
      {selectedTab === BUILDER_DEVICE_TAB.APPLE && (
        <Flex>
          <AppleAppLinks />
        </Flex>
      )}
      {selectedTab === BUILDER_DEVICE_TAB.GOOGLE && <GoogleAppLinks />}
    </SectionWrapper>
  );
};

export default AppLinkingFeature;
